import React from "react";
import SEO from "@/components/SEO";

export default function Legal({ kind = "privacy" }) {
  const isPrivacy = kind === "privacy";
  return (
    <>
      <SEO title={isPrivacy ? "Privacy Policy" : "Terms"} path={isPrivacy ? "/privacy" : "/terms"} />
      <section className="container-x section-y max-w-3xl">
        <h1 className="font-heading text-4xl font-black tracking-tight">{isPrivacy ? "Privacy Policy" : "Terms & Conditions"}</h1>
        <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800">
          This is placeholder legal text pending review by VoiceOverKids. Final wording requires legal review before launch.
        </div>
        <div className="prose mt-8 space-y-4 text-zinc-600">
          {isPrivacy ? (
            <>
              <p>VoiceOverKids.Agency (De Savornin Lohmanplein 2, 2314 EV Leiden, The Netherlands) respects your privacy and protects the personal data of clients and child performers.</p>
              <p><strong>Child privacy:</strong> We never publish private surnames, birth dates, addresses, schools or guardian contact details of child performers. Only intentionally published public information is shown.</p>
              <p><strong>Data we collect:</strong> Contact and casting enquiry details you submit are stored to respond to your request. We do not load non-essential tracking without consent where required.</p>
              <p><strong>Your rights:</strong> You may request access, correction or deletion of your personal data by emailing bookings@voiceoverkids.agency.</p>
            </>
          ) : (
            <>
              <p>Use of AI voices and human recordings is subject to a licence covering the agreed usage and territory. Commercial/broadcast usage requires the appropriate buyout.</p>
              <p>For AI commercial licensing contact licensing@voiceoverkids.agency.</p>
              <p>All bookings are subject to child availability, working regulations and guardian consent.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
}
